<template>
    <b-standard-card
        :title="translations.title[lang]"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :loading="loading"
        class="mt-5"
        height="auto"
        :error-message="errorMessage"
        @submit="updateCampaignEmailNotifications({type: 'campaign_email_notification',
         item: campaign_email_notifications,})"
    >

        {{ translations.notificationsInfo[lang] }}


        <v-row v-for="(item, index) in campaign_email_notifications" :key="index" no-gutters
               align="baseline">
            <v-col
                cols="auto"
                class="subtitle-1 font-weight-bold secondary--text"
            >
                {{ index == 'email1' ? "1." :  index == 'email2' ? "2." : "3."}}
            </v-col>
            <v-col cols="7" class="pl-3">
                <b-text-field v-model="campaign_email_notifications[index]"></b-text-field>
            </v-col>
        </v-row>
    </b-standard-card>
</template>

<script>
import translations from "@/utils/translations/loyaltyPanel/businessProfile/campaignCredentials";
import {mapState, mapGetters, mapMutations, mapActions} from "vuex";

export default {
    name: "CampaignCredentials",

    mixins: [translations],
    data() {
        return {
            campaign_email_notifications: {
                email1: "",
                email2: "",
                email3: ""
            }
        }
    },

    computed: {
        lang() {
            return this.$route.params.lang;
        },
        loading() {
            return this.$store.state.loyaltyPanel.businessProfile.loading.campaign_email_notification;
        },

        errorMessage() {
            return this.$store.state.loyaltyPanel.businessProfile.errorMessage
                .campaign_email_notification;
        },
        resetSuccess() {
            return this.$store.state.loyaltyPanel.businessProfile.resetSuccess
                .campaign_email_notification;
        },


    },
    methods: {
        ...mapActions("loyaltyPanel/businessProfile", [
            "updateCampaignEmailNotifications"
        ]),

        getCampaignCredentials() {
            let campaign_data = this.$store.state.loyaltyPanel.businessProfile;
            this.campaign_email_notifications = campaign_data.compaignCrendential;
        }
    },

    watch:{
        ["$store.state.loyaltyPanel.businessProfile.businessProfileData"]: {
            handler(val) {
                this.campaign_email_notifications = val.campaign_email_notifications;
            }
        },
    },
    mounted() {
        this.getCampaignCredentials();
    }

};
</script>
